// Email edits on the user page are opt-in: the address only changes after the
// admin clicks "Change email". The page used to render the email as an always
// present (read-only) input and send it on every save, so a browser or password
// manager that autofilled it (e.g. with the admin's own address) turned an
// entitlement-only save into an email change. omg-api then tried to move the
// login to an address another account owns and the save failed with "An
// account with that email already exists."

/**
 * The email to send in the PATCH, or undefined to leave it alone. Only a
 * deliberate edit (the Change email control) that actually differs from the
 * loaded address, after the same trim + lowercase omg-api applies, is sent.
 */
export const emailToSend = ({
  editingEmail,
  draftEmail,
  loadedEmail,
}: {
  editingEmail: boolean;
  draftEmail: string | undefined;
  loadedEmail: string | undefined;
}): string | undefined => {
  if (!editingEmail) return undefined;
  const next = (draftEmail ?? "").trim().toLowerCase();
  if (!next) return undefined;
  return next === (loadedEmail ?? "").trim().toLowerCase() ? undefined : next;
};

/**
 * Attributes that ask the browser and the common password managers (1Password,
 * LastPass, Bitwarden, Dashlane) not to fill the field. Belt and braces: the
 * input is only rendered after an explicit click, so this covers the editing
 * window itself.
 */
export const NO_AUTOFILL_PROPS = {
  autoComplete: "off",
  "data-1p-ignore": "true",
  "data-lpignore": "true",
  "data-bwignore": "true",
  "data-form-type": "other",
} as const;
